import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'

export const TailoredIcon = styled.img``
export const TailoredTitle = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  margin: 0px 8px;
  white-space: nowrap;
`

export const TailoredWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  &:hover {
    color: ${props => (props.disabled ? Colors.Neutral50 : Colors.Blue50)};
  }

  ${TailoredTitle} {
    color: ${props => props.disabled && Colors.Neutral50};
  }
`
